import React, { useState, useEffect } from 'react'
import { Link, Button, TextCallout2, TextSubHeading, colors, IconExternal } from '@blocket/blocket-ui'
import pulse from '@blocket/tracking-pulse'
import styled from "styled-components"

import styleguide from 'styleguide'
import { useDecision } from '@optimizely/react-sdk'

const CompanyArticle = `https://blocket.zendesk.com/hc/sv/articles/10284177136668`

const StyledLink = styled(Link)`
  text-decoration: underline;
  font-size: 15px;
  line-height: 2rem;
  * {
    color: ${colors.blue600}
  }
`
const StyledIconEternal = styled(IconExternal)`
  height: 14px;
  width: 14px;
  margin-left: 4px;
`

const StyledTextCallout2 = styled(TextCallout2)`
  display: flex;
  align-items: center;
  margin: ${styleguide.padding.small}px;
  margin-left: 0px;
`

const StyledCompanyInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 4px;
  border-left: 4px solid ${colors.blue600};
  background-color: ${colors.blue50};

  padding: 16px 20px;
`

const InfoBoxButton = styled(Button)`
  button {
    padding: 0px 24px;
  }
`

const InfoBoxTitle = styled(TextSubHeading)`
  margin-bottom: 8px;
`

const InfoBoxDescription = styled(TextCallout2)`
  margin-bottom: 12px;
`

const sendCompanyAdvertisementClickEvent = () => {
  pulse.event({
    type: 'Engagement',
    action: 'Click',
    name: 'Advertise as a company',
    object: {
      id: 'company-advertisement',
      type: 'UIElement',
      elementType: 'Link',
    },
  })
}


const INFOBOX_SEMIPRO_RECOMMERCE_CAT_DISMISSED = 'HasUserDismissedSemiProInfoBox'

const useSemiProRecommCatInfoboxState = () => {
  const [hasUserDismissedInfoBox, setHasUserDismissedInfoBox] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [decision] = useDecision('recommerce_company_ai_for_apps')

  useEffect(() => {
    const loadInfoBoxState = () => {
      const hasUserDismissedInfoBoxLS = localStorage.getItem(INFOBOX_SEMIPRO_RECOMMERCE_CAT_DISMISSED) === 'true'
      setHasUserDismissedInfoBox(hasUserDismissedInfoBoxLS)
      setIsLoaded(true)
    }

    if (typeof window !== 'undefined') {
      loadInfoBoxState()
    }
  }, [])

  function handleInfoBoxDismissed() {
    setHasUserDismissedInfoBox(true)
    window.localStorage.setItem(INFOBOX_SEMIPRO_RECOMMERCE_CAT_DISMISSED, 'true')
  }

  const isAbTestEnabledForInfoBox = decision.enabled && decision.variables.page_variant === 'A'

  return [
    // shouldShowInfoBox
    // if user has not dismissed the infobox yet,
    // the feature flag is enabled on variant A and the infobox is status loaded is loaded from localStorage
    !hasUserDismissedInfoBox && isAbTestEnabledForInfoBox && isLoaded,
    handleInfoBoxDismissed
  ]
}

export const CompanyAdInsertionLink = () => {
  return (
    <StyledLink
      href={CompanyArticle}
      onClick={sendCompanyAdvertisementClickEvent}
    >
      <StyledTextCallout2>Information för dig som är företag<StyledIconEternal /></StyledTextCallout2>
    </StyledLink>
  )
}

const CompanyBlueInfoBox = () => {
  const [shouldShowInfoBox, handleInfoBoxDismissed] = useSemiProRecommCatInfoboxState()

  return (
    <>
      {shouldShowInfoBox && (
        <StyledCompanyInfo>
          <InfoBoxTitle>Nyhet för dig som är företag!</InfoBoxTitle>
          <InfoBoxDescription>
              Nu kan du även publicera företagsannonser i kategorierna För hemmet, Fritid & hobby, Elektronik, Personligt och Övrigt. Välj respektive kategori för att skapa annons.
          </InfoBoxDescription>
          <InfoBoxButton type="primary" size="tiny" onClick={handleInfoBoxDismissed}>
            Ok, jag fattar
          </InfoBoxButton>
        </StyledCompanyInfo>
      )}
    </>
  )
}

export default CompanyBlueInfoBox
